import { useEffect, useState } from "react";
import { applyTheme, loadThemePref, saveThemePref } from "../lib/theme";
import { tg } from "../lib/telegram";

export function ThemeToggle() {
  const [isDark, setIsDark] = useState(() =>
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("theme-dark"),
  );

  // Keep in sync if some other code (e.g. Profile's switch) flips the theme.
  useEffect(() => {
    const html = document.documentElement;
    const observer = new MutationObserver(() => {
      setIsDark(html.classList.contains("theme-dark"));
    });
    observer.observe(html, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  function toggle() {
    const pref = loadThemePref();
    // If currently on "auto", commit to the opposite of what's displayed.
    // Otherwise just flip.
    const next = isDark ? "light" : "dark";
    saveThemePref(next);
    applyTheme(next);
    tg()?.HapticFeedback?.impactOccurred("light");
    // pref unused beyond resolving; the variable is here for future "auto" handling.
    void pref;
  }

  return (
    <button
      onClick={toggle}
      aria-label={isDark ? "Светлая тема" : "Тёмная тема"}
      className="w-10 h-10 rounded-full flex items-center justify-center bg-ink-50 border border-ink-100 text-ink-700 active:scale-90 transition-all"
    >
      {isDark ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}

function SunIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}
